<div class="relative h-full hot-deal-item-container rounded-lg cursor-pointer">
    <a  class="h-full block hot-deal-item rounded-lg cursor-pointer font-inter col-span-1"
        [href]="generateFullUrl(item)" target="_blank" rel="noopener"
    >
        <div class="h-full flex flex-col">
            <div class="!p-2 image-container relative">
                <img *ngIf="item.property_image_overview_id" loading="lazy"
                    class="seo-image rounded-lg aspect-[16/9] w-full max-h-[118px] object-cover"
                    src="{{baseImageId}}/{{ item.property_image_overview_id }}.webp" (error)="replaceWithDefaultImage($event)" alt=" ">
                <img 
                    *ngIf="!item.property_image_overview_id"
                    loading="lazy"
                    class="seo-image rounded-lg aspect-[16/9] w-full max-h-[118px] object-cover"
                    src="{{ item.property_image_overview_url }}"
                    (error)="replaceWithDefaultImage($event)"
                    alt=" "
                >
                <!-- <div *ngIf="item?.discount_percent && item.discount_percent > 0"
                    class="discount-rate text-white px-[6px] py-1 rounded-tr-md rounded-bl-md absolute bottom-3 left-3 text-xs text-center font-semibold leading-4">
                    <p>-{{item.discount_percent}}%</p>
                </div> -->
                <ng-container *ngIf="item?.badge_info">
                    <div class="absolute bottom-3 left-3 flex z-10 rounded-sm"
                        (mouseover)="item.badge_info?.badge_info.showTooltip = true;"
                        (mouseleave)="item.badge_info?.badge_info.showTooltip = false;">
                        <div class="relative z-10">
                            <img class="!w-8 !h-8 !p-0.5 rounded" src="{{baseImageId}}/{{ item.badge_info.badge_info.avatar}}.webp" alt="">
                            <div *ngIf="item.badge_info?.badge_info.showTooltip"
                                class="absolute text-xs font-medium text-palette-gray-900 bg-palette-gray-50 
                                    !px-3 !py-2 rounded shadow-md left-full bottom-0 ml-1 whitespace-nowrap z-10">
                                {{ item.badge_info.badge_info.name }}
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
            <div class="flex-1 bg-white !px-3 !pb-3 relative rounded-lg flex flex-col gap-2">
                <div class="flex flex-col">
                    <div class="flex justify-start items-center relative">
                        <div class="flex gap-[1px]">
                            <div 
                                [tooltip]="'DETAIL.DESCRIPTION_STAR' | translate"
                                [position]="TooltipPosition.ABOVE"
                                [theme]="TooltipTheme.DARK_LIGHT"
                                class="!h-6"
                            >
                                <app-star 
                                    [count]="item.star"
                                    starStyle="!gap-0.5"
                                    iconStyle="sctr-icon-solid-star-01 text-palette-yellow-400 text-sm">
                                </app-star>
                            </div>
                        </div>
                    </div>
                    <div class="relative h-[40px]">
                        <h1 
                            [tooltip]="item.property_name"
                            [isTruncated]="true"
                            [position]="TooltipPosition.BELOW"
                            class="seo-title property-name text-sm not-italic font-semibold leading-5 text-palette-gray-900"
                        >
                            {{ item.property_name }}
                    </h1>
                    </div>
                    <div class="flex items-center relative" (click)="openMap($event, item)">
                        <common-icon-text 
                            class="!w-full text-ellipsis overflow-hidden flex items-center"
                            [icon]="'sctr-icon-marker-pin-01'"
                            [iconStyle]="'text-base !leading-5 mr-1 opacity-70'"
                            [text]="item.address"
                            [textStyle]="'text-soctrip-small font-normal text-palette-gray-500 whitespace-nowrap text-ellipsis overflow-hidden'"
                            [dataCyValue]="'address-hotel'">
                        </common-icon-text>
                    </div>
                    <div class="h-4 grid grid-cols-8 !gap-2 [&>*:nth-child(n+9)]:hidden">
                        <ng-container *ngFor="let facility of renderAmenityList(item.property_amenity_list)">
                            <div class="icon-service col-span-1 !w-4 h-4 flex items-center">
                                <i class="amenity-icon sctr-icon-{{facility.amenity_icon}}"></i>
                            </div>
                        </ng-container>
                    </div>
                </div>
                <!-- <div *ngIf="!isOverflowPrice" #containerElementRef class="flex items-center gap-[6px] h-6">
                    <app-price-format [price]="item.net_price"
                        [styleClass]="'seo-price text-palette-orange-dark-500 text-base font-medium !leading-6'"></app-price-format>
                    <app-price-format [price]="item.original_price"
                        [styleClass]="'seo-price text-palette-gray-500 text-sm whitespace-nowrap text-ellipsis overflow-hidden line-through'"></app-price-format>
                </div> -->
                <ng-container *ngIf="item.badge_info">
                    <div class="w-full rank-discount-background !px-2 !py-1 !h-[34px] flex items-center justify-start !gap-1 relative"
                        (mouseover)="item.badge_info.rank_info.showTooltip = true"
                        (mouseleave)="item.badge_info.rank_info.showTooltip = false">
                        <img class="!w-6 !h-6 !p-0.5" src="{{baseImageId}}/{{item.badge_info.rank_info.avatar}}.webp" alt="">
                        <div class="flex flex-col">
                            <p class="text-[8px] leading-3 font-normal text-palette-gray-500 whitespace-nowrap">
                                {{ 'SEARCH_RESULT.DISCOUNT' | translate }}
                            </p>
                            <p class="text-xs font-semibold text-palette-gray-900 !pl-0.5 !pr-1">
                                {{ item.badge_info.rank_info.reduce_amount | currencyConversion }}
                            </p>
                        </div>
                        <div *ngIf="item.badge_info.rank_info.showTooltip"
                            class="absolute text-xs font-medium text-palette-gray-900 bg-palette-gray-50 
                                !px-3 !py-2 rounded shadow-md bottom-full !mb-1 whitespace-nowrap z-10">
                            {{ item.badge_info.rank_info.name }}
                        </div>
                    </div>
                </ng-container>
                <div class="flex flex-col items-end justify-end !mt-auto">
                    <div *ngIf="item.original_price !== item.net_price" class="flex !gap-1 items-center">
                        <p class="w-fit bg-palette-blue-600 text-white text-[8px] leading-3 font-normal !px-2 !py-1 rounded-lg whitespace-nowrap md:mt-0">
                            {{ 'DETAIL.OFF' | translate: { syntax: item.discount_percent } }}
                        </p>
                        <app-price-format 
                            [price]="item.original_price"
                            [styleClass]="'seo-saling-price text-palette-gray-500 text-sm whitespace-nowrap text-ellipsis overflow-hidden line-through'">
                        </app-price-format>
                    </div>
                    <app-price-format
                        [price]="item.net_price"
                        [styleClass]="'seo-price text-palette-orange-dark-500 text-base font-medium !leading-6'">
                    </app-price-format>
                </div>
            </div>
        </div>
    </a>
    <button class="btn-favorite flex justify-center !h-7 bg-palette-gray-900 bg-opacity-40 rounded-lg p-[6px] absolute top-4 right-4 text-center"
        (click)="handleBookmark($event)">   
        <i
            class="!text-base !leading-4"
            [ngClass]="{ 'sctr-icon-solid-bookmark text-palette-amber-400': isBookmarked, 'text-white sctr-icon-bookmark': !isBookmarked }">
        </i>
    </button>
</div>

<app-toast keyToast="hd"></app-toast>